/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Ideal_Halibut_AmazeInputs */

const fr_stock_ideal_halibut_amaze = /** @type {(inputs: Stock_Ideal_Halibut_AmazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribuer un programme`)
};

/**

* @param {Stock_Ideal_Halibut_AmazeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stock_ideal_halibut_amaze = /** @type {((inputs?: Stock_Ideal_Halibut_AmazeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Ideal_Halibut_AmazeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stock_ideal_halibut_amaze(inputs)
});